import React, { useState, useEffect, Fragment, useMemo } from "react";
import SectionCard from "./SectionCard";
import ButtonComponent from "./Button_v2";
import CustomerOrderDetails from "../../components/orders/CustomerOrderDetails";
import I18n from "../../common/I18n";
import { Col, Row, Select, Modal, Icon, Spin } from "../../common/UIComponents";
import OrderFieldDisplay from "../../components/orders/OrderFieldDisplay";
import Search_v2 from "./Search_v2";
import {
  checkServiceExistance,
  renderAlertMessage,
} from "../../helpers/common";
import userStore from "../../stores/UserStore";
import { getSearchValueSubOrders, saveSubOrders, updateOrderDetails_v2 } from "../../api/OrdersApi";
import _, { isEqual } from "lodash";
import { alertMessage, navigateToAccount } from "../../common/Common";
import { fetchAccountShortLos } from "../../api/Los";
import TypeOfOrder from "../../components/orders/TypeOfOrder";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./SubOrders.scss";

const SubOrders = (props) => {
  const { getDataRef, targetWarehouse, warehouseFilter, subOrders, showSave, 
    currentOrg = {}, currentOrder = {}, refreshDetails = () => {}, isShipper = false, showActions = true, screenMode = "" } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [ordersDataSource, setOrdersDataSource] = useState([]);
  const [accountLOS, setAccountLOS] = useState({});
  const [loading, setLoading] = useState(false);
  const [targetAccounts, setTargetAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if(_.isArray(subOrders) && subOrders.length > 0){
      setDataSource(subOrders)
      setLosOfAccounts()
    }
  }, [subOrders])

  useEffect(() => {
    if (targetWarehouse) {
      const accountsData = warehouseFilter.findMatchingAccounts(targetWarehouse);
      setTargetAccounts(accountsData)
    }
    if (getDataRef) {
      getDataRef.current = () => dataSource
    }
  }, [targetWarehouse])

  useEffect(() => {
    if (getDataRef) {
      getDataRef.current = () => dataSource
    }
  }, [dataSource, getDataRef]);

  // const areSubOrdersSame = (arr1, arr2) => {
  //   if (arr1.length !== arr2.length) return false;
  
  //   return (
  //     arr1.every((obj1) => arr2.some((obj2) => isEqual(obj1, obj2))) &&
  //     arr2.every((obj2) => arr1.some((obj1) => isEqual(obj1, obj2)))
  //   );
  // };

  // const isSame = useMemo(() => areSubOrdersSame(subOrders, dataSource), [subOrders, dataSource]);

  // Function to handle saving sub orders
  const handleSave = (subOrders = null) => {
    const associateOrders = subOrders || dataSource
    const organization_id = currentOrg?.id || '';
    const warehouseId = props?.selectedWarehouse?.id || '';
    const payload = {
      organization_id: organization_id,
      warehouse_ids: warehouseId,
      id: currentOrder.id,
      customer_order_params: {
        customer_order_id: currentOrder.id,
        warehouse_id: currentOrder?.customer_order_details?.warehouse_id || '',
        organization_id: currentOrg?.id || '',
        location_id: ''
      },
      sub_order_details: {
        lh_order_ids: associateOrders.map(order => order.id),
        sub_orders: associateOrders.map(order => ({
          "order_id": order.id,
          "target_account":order.target_account_id || '',
          "target_los":order.target_los_id || '',
        })),
        target_warehouse_id: targetWarehouse
      }
      
    };
    // setIndexLoading(true);
    // setLoading(true);
    updateOrderDetails_v2(currentOrder.id,payload).then((res) => {
      if (res.success) {
        renderNotification(
          `Order ${currentOrder.customer_order_details.customer_order_number} details has been updated`,
          "success"
        );
        setIsLoading(false);
        refreshDetails()
        if (res?.data?.warnings.length > 0) {
          alertMessage(res?.data?.warnings, "success", 10);
        }
      } else {
        setIsLoading(false);
        alertMessage(res?.errors[0], "error", 10);
      }
    });
  };

  // Function to find sub orders based on search text
  const findSubOrders = (searchText) => {
    if (searchText !== "") {
      const warehouseId = props?.selectedWarehouse?.id;
      const organization_id = userStore.getStateValue("selectedOrg");
      const search_value = searchText;
      setLoading(true);
      getSearchValueSubOrders(search_value, organization_id, warehouseId).then(
        (res) => {
          if (!_.isEmpty(res.orders)) {
            setOrdersDataSource(res.orders);
            setLoading(false);
          } else {
            setLoading(false);
            alertMessage(
              res?.errors?.length > 0 ?
              res.errors.join(", ") :
              "No orders found (or) Order(s) are already assigned.",
              "error",
              10
            );
          }
        }
      );
    } else {
      alertMessage("Please enter your required number..!!", "error", 5);
    }
  };

  // const setLosOfAccounts = async () => {
  //   const record = {};
  //   try {
  //     subOrders.forEach(async order => {
  //         const response = await fetchAccountShortLos(order.target_account_id, 'LH', "account_id");
  //         if (response.success) {
  //           record[order.target_account_id] = response.account.account_los || [];
  //       }
  //     } )
  //   } catch (error) {
  //     console.error('Error processing lineHaulOrders:', error);
  //   }
  
  //   setAccountLOS(record);
  // }

  useEffect(() => {
    if (!_.isEmpty(accountLOS)) {
      setDataSource([...dataSource]); // Trigger re-render
    }
  }, [accountLOS]);

  const setLosOfAccounts = async () => {
    const record = { ...accountLOS };
    for (const order of subOrders) {
      if (!record[order.target_account_id]) { // Check if already exists
        try {
          const response = await fetchAccountShortLos(order.target_account_id, "LH", "account_id");
          if (response.success) {
            record[order.target_account_id] = response.account.account_los || [];
          }
        } catch (error) {
          console.error(`Error fetching ${I18n.t("general.short_los")}:`, error);
        }
      }
    }
    setAccountLOS(record);
  };

  // Function to handle updating an order
  const handleUpdateOrder = (index, id, element, value) => {
    const orders = [...dataSource];
    orders[index][element] = value;
    if (element === "target_account_id") {
      orders[index]["target_los_id"] = "";
      const targetObject = value ? _.find(targetAccounts, { id: value }) : null;
      if (value && targetObject) {
        getTargetLos(value, targetObject.code);
      }
    }
    setDataSource(orders);
  };

  // Function to get target LOS
  const getTargetLos = (accountId, accountCode) => {
    if (!isEmpty(accountCode) && !accountLOS[accountId]) {
      setLoading(true);
      fetchAccountShortLos(accountCode, "LH").then((result) => {
        if (result.success) {
          const los = result.account.account_los || [];
          setAccountLOS({ ...accountLOS, [accountId]: los });
          setLoading(false);
        } else {
          setLoading(false);
          renderAlertMessage(result.errors);
        }
      });
    }
  };

  // Function to handle add orders button click
  const handleAddOrdersClick = () => {
    setIsModalVisible(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  // Function to delete a row
  const handleDeleteRow = (recordId) => {
    const updatedDataSource = dataSource.filter((row) => row.id !== recordId);
    setDataSource(updatedDataSource);
    if(screenMode === "view" && updatedDataSource.length === 0){
      handleSave([])
    }
  };

  // Function to add orders to sub orders
  const handleAddRowOrders = (record) => {
    const isDuplicate = dataSource.some((row) => row.id === record.id);
    if (!isDuplicate) {
      const newRow = {
        id: record.id, // Use the same id from the modal data
        customer_order_number: record.customer_order_number,
        type_of_order: record.type_of_order,
        order_label: record.order_label,
        hawb: record.hawb,
        mawb: record.mawb,
        reference_1: record.reference_1,
        reference_2: record.reference_2,
        account_name: record.account_name,
        account_code: record.account_code,
        account_id: record.account_id,
        los_name: record.los_name,
        target_account_id: record.target_account_id,
        target_account: record.target_account,
        target_los_id: record.target_los_id,
        target_los: record.target_los,
      };
      setDataSource([...dataSource, newRow]); // Add the new row to the main table
    }
  };

  // Function to get columns for the table
  const getColumns = (isInModal) => {
    const columns = [
      {
        key: "customer_order_number",
        field: "customer_order_number",
        headerName: I18n.t("order.order_no"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 130,
        cellRenderer: (params) => {
          const record = params.data;
         
          const text = record.customer_order_number;
          return (
            <div>
              <CustomerOrderDetails
                order_no={text}
                order={{
                  id: record.id,
                  customer_order_number: text,
                }}
                showEdit={false}
              />
            </div>
          );
        },
      },
      {
        key: "type_of_order",
        field: "type_of_order",
        headerName: I18n.t("general.order_type"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 150,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div
              className="type-of-order-tag-container"
              style={{ textAlign: "center" }}
            >
              <TypeOfOrder
                order={record}
                orderTypeKey="type_of_order"
                relatedOrderKey="related_order"
                placement="topLeft"
                showBadge={true}
                isInAggrid={false}
                isReenderWithIcon={true}
              />
            </div>
          );
        },
      },
      {
        key: "hawb",
        field: "hawb",
        headerName: I18n.t("general.hawb"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 120,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <OrderFieldDisplay
              data={{
                ...record,
                id: record.id,
                customer_order_number: record.customer_order_number,
              }}
              toDisplay="hawb"
              showTriggerEdit={false}
              showEditIcon={false}
            />
          );
        },
      },
      {
        key: "mawb",
        field: "mawb",
        headerName: I18n.t("general.mawb"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 120,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <OrderFieldDisplay
              data={{
                ...record,
                id: record.id,
                customer_order_number: record.customer_order_number,
              }}
              toDisplay="mawb"
              showTriggerEdit={false}
              showEditIcon={false}
            />
          );
        },
      },
      {
        key: "reference_1",
        field: "reference_1",
        headerName: `${I18n.t("order.reference")} 1`,
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 120,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <OrderFieldDisplay
              data={record}
              toDisplay="reference_1"
              showPopupContainer={true}
            />
          );
        },
      },
      {
        key: "reference_2",
        field: "reference_2",
        headerName: `${I18n.t("order.reference")} 2`,
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 120,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <OrderFieldDisplay
              data={record}
              toDisplay="reference_2"
              showPopupContainer={true}
            />
          );
        },
      },
      {
        key: "account",
        field: "account_name",
        headerName: I18n.t("account.account"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 180,
        cellRenderer: (params) => {
          const record = params.data;
          const data = record.account_name;
          const hasAccess = checkServiceExistance(["OPSAS", "ACNF"], "ALL");
          return (
            <div>
              {hasAccess && record.account_code ? (
                //     <Link
                //       className={hasAccess ? "anchor_cursor" : ""}
                //       onClick={() => {
                //         if (hasAccess) {
                //           navigateToAccount(record.account_id);
                //         }
                //       }}
                //     >
                //       {data}
                //     </Link>
                <span>{data}</span>
              ) : !isEmpty(data) ? (
                data
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        key: "los",
        field: "los_name",
        headerName: I18n.t("general.short_los"),
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 120,
      },
      !isInModal && {
        key: "target_account",
        field: "target_account_id",
        headerName: "Target Account",
        headerClass: "header-style",
        cellClass: "noWrap cell-style",
        width: 150,
        cellRenderer: (params) => {
          //     const isReadOnly = props.isReadOnly;
          const isReadOnly = isShipper; // false
          const record = params.data;
          const index = params.rowIndex;

          return (
            <Row>
              <Col>
                {isReadOnly ? (
                  <div>{record.target_account}</div>
                ) : (
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      handleUpdateOrder(
                        index,
                        record.id,
                        "target_account_id",
                        e
                      )
                    }
                    value={record.target_account_id}
                    size="small"
                    dropdownMatchSelectWidth={false}
                  >
                    <Select.Option key="account" value="">
                      {" "}
                      -- Select --{" "}
                    </Select.Option>
                    {targetAccounts.map((account) => (
                      <Select.Option key={account.code} value={account.id}>
                        {`${account.name} (${account.code})`}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Col>
            </Row>
          );
        },
      },
        !isInModal && {
          key: "target_los",
          field: "target_los_id",
          headerName: "Target " + I18n.t("general.short_los"),
          headerClass: "header-style",
          cellClass: "noWrap cell-style",
          width: 120,
          cellRenderer: (params) => {
            //     const isReadOnly = props.isReadOnly;
            const isReadOnly = isShipper //false;
            const record = params.data;            
            const index = params.rowIndex;
            return (
              <Row>
                <Col>
                  {isReadOnly ? (
                    <div>{record.target_los}</div>
                  ) : (
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      onChange={(e) =>
                        handleUpdateOrder(index, record.id, "target_los_id", e)
                      }
                      value={record.target_los_id}
                      size="small"
                      dropdownMatchSelectWidth={false}
                    >
                      <Select.Option key="LOS" value="">
                        {" "}
                        -- Select --{" "}
                      </Select.Option>
                      {_.isArray(accountLOS[record.target_account_id]) &&
                        accountLOS[record.target_account_id].map((los) => (
                          <Select.Option key={los.code} value={los.id}>
                            {los.name}
                          </Select.Option>
                        ))}
                      <Select.Option key="none" value="NONE">
                        None
                      </Select.Option>
                    </Select>
                  )}
                </Col>
              </Row>
            );
          },
        },
        !isShipper && {
        key: "action",
        headerName: "",
        width: 50,
        pinned: "right",
        resizable: false,
        cellRenderer: (params) => {
          const record = params.data;
          return (
            <div>
              {isInModal ? (
                dataSource.some((row) => row.id === record.id) ? (
                  <Icon type="check-circle" style={{ color: "green", fontSize: "20px" }} />
                ) : (
                  <Icon
                    type="plus-circle"
                    style={{ color: "#576EC1", fontSize: "20px" }}
                    onClick={() => handleAddRowOrders(record)}
                  />
                )
              ) : (
                <Icon
                  type="minus-circle"
                  style={{ color: "#1D2540", fontSize: "20px" }}
                  onClick={() => handleDeleteRow(record.id)}
                />
              )}
            </div>
          );
        },
      },
    ].filter(Boolean);

    return columns;
  };

  return (
    <Spin spinning={isLoading}>
      <SectionCard
        className="sub-orders-section"
        title="Associated Orders"
        extraActionNode={
          showActions && !isShipper && (
            <ButtonComponent
              type="secondary"
              className="outline small-btn"
              onClick={handleAddOrdersClick}
              text="Add Orders"
            />
          )
        }
      >
        {dataSource.length > 0 && (
          <Fragment>
            <div
              className="ag-theme-alpine"
              style={{ height: 250, marginTop: "16px" }}
            >
              <AgGridReact
                className="sub-orders-table"
                columnDefs={getColumns(false)}
                rowData={dataSource}
                pagination={false}
                headerHeight={40}
                rowHeight={40}
                style={{ marginTop: "16px" }}
                scroll={{ x: "max-content" }}
              />
            </div>
            {showSave && (
              <Row>
                <Col xs={24} style={{ marginTop: 8 }}>
                  <ButtonComponent
                    type="secondary"
                    className="outline small-btn"
                    onClick={() => handleSave()}
                    text="Save"
                  />
                </Col>
              </Row>
            )}
          </Fragment>
        )}

        <Modal
          visible={isModalVisible}
          title="Search Orders to Add"
          onCancel={handleCloseModal}
          footer={null}
          width="80%"
          bodyStyle={{ height: "600px" }}
        >
          <Search_v2
            placeholder="Search Order #, HAWB, MAWB, Reference #, etc"
            onSearch={findSubOrders}
          />
          <div
            className="ag-theme-alpine items-measure-table"
            style={{ height: 510, marginTop: "16px" }}
          >
            <AgGridReact
              className="sub-orders-table"
              columnDefs={getColumns(true)}
              loading={loading}
              rowData={ordersDataSource ? ordersDataSource : []}
              headerHeight={40}
              rowHeight={40}
              pagination={false}
              scroll={{ x: "max-content", y: "calc(100vh - 400px)" }}
            />
          </div>
        </Modal>
      </SectionCard>
    </Spin>
  );
};

export default SubOrders;
